export default {
  inject: ['formContext'],
};
